import React, { useContext } from "react";
import errImg from "../../Images/404.png";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext";
import { roles } from "../../Config/Roles";

const NotFound = () => {
  const { roleId, tenantId } = useContext(AuthContext);
  const { master, admin, support } = roles;

  return (
    <div className="container" style={{ marginTop: 70 }}>
      <div className="col-md-8 offset-2">
        <h2>Ups! Tražena stranica nije pronađena :/</h2>
        <p>
          Stranicu nije moguće pronaći jer je možda privremeno nedostupna,
          uklonjena ili joj je promijenjeno ime. Povratak na{" "}
          <Link
            to={
              [master, admin, support].includes(Number(roleId))
                ? "/"
                : `/tenants/${tenantId}`
            }
          >
            naslovnicu
          </Link>
          .
        </p>
      </div>
      <div className="col-md-8 offset-2 text-center">
        <img src={errImg} alt="404" />
      </div>
    </div>
  );
};

export default NotFound;
